/* 系统常量API */

import { GET, POST, download, uploading, POSTFormData } from '@/request/http'

/**
 * 运行模式类型
 */
export const getworkmodetype = p => POST('/equipment/constant/workmodetype', p, 1)
/**
 * 设备类型
 */
export const getequipmenttype = p => POST('/equipment/constant/equipmenttype', p, 1)
/**
 * 模块类型
 */
export const getmoduletype = p => POST('/equipment/constant/moduletype', p, 1)
/**
 * 模块公司
 */
export const getmodulecompany = p => POST('/equipment/constant/modulecompany', p, 1)



// WEBPACK FOOTER //
// ./src/api/modules/constant.js